import { Directive, Input, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

export enum Direction {
  ASC = 'asc',
  DESC = 'desc'
}

export type SortDirection = Direction.ASC | Direction.DESC | '';
const rotate: { [key: string]: SortDirection } = { asc: Direction.DESC, desc: Direction.ASC, '': Direction.ASC };

export interface SortEvent {
  column: string;
  direction: SortDirection;
}

@Directive({
  selector: 'th[appSortable]'
})
export class SortableDirective {
  @Input() sortBy: string;
  @Input() direction: SortDirection = '';
  @Output() sort: EventEmitter<SortEvent> = new EventEmitter<SortEvent>();

  constructor() {}

  @HostBinding('class.asc') 'direction === "asc"': any;

  @HostBinding('class.desc') 'direction === "desc"': any;

  @HostListener('click')
  rotate(): void {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortBy, direction: this.direction });
  }
}
